/*global _ */
import {
    min,
    max,
    floor,
    ceil,
    seconds2Hours,
    elements,
} from './config'

export default {
    data() {
        return {
            startTime: '',
            endTime: '',
            originalScaleWidth: 0,
            els: _.cloneDeep(elements),
        }
    },
    computed: {
        frames() {
            return this.data?.frames || []
        },
    },
    watch: {},

    created() {

    },
    mounted() {
        this.probeElements()
    },
    methods: {
        getFrameStyle(frame) {
            return {
                'background-image': `url('${frame}')`
            }
        },
        probeElements() {
            const el = this.$el
            this.els = _.mapValues(elements, e => el.querySelector(e))
            this.originalScaleWidth = this.els.frames.clientWidth
        },
        updateTimeDisplay() {
            const val = this.innerValue
            this.starTime = ''
            this.endTime = ''
            const {start, end} = val || {}
            if (_.isNumber(start)) {
                this.startTime = seconds2Hours(start)
            }
            if (_.isNumber(end)) {
                this.endTime = seconds2Hours(end)
            }

            this.$nextTick(() => {
                const totalWidth = this.els.context.clientWidth
                const startE = this.els.start
                const endE = this.els.end
                const startT = this.els.startText
                const startTWidth = startT.clientWidth
                const endT = this.els.endText
                const endTWidth = endT.clientWidth
                const overlapOffset = 5

                if (!startT.hasAttribute('data-original-height')) {
                    startT.setAttribute('data-original-height', startT.clientHeight)
                }
                const startTOriginalHeight = startT.getAttribute('data-original-height')

                let startPos = max([
                    0,
                    floor((startE.offsetLeft + startE.clientWidth / 2) - (startTWidth / 2))
                ])

                let endPos = max([
                    0,
                    floor(totalWidth - (endE.offsetLeft + endE.clientWidth / 2 + endTWidth / 2)),
                ])

                const startTRight = startPos + startTWidth
                const endTLeft = totalWidth - endPos - endTWidth

                const isOverlapping = (startTRight + overlapOffset) > (endTLeft - overlapOffset)
                let needsToHoistStart = false
                if (isOverlapping) {
                    needsToHoistStart = startPos <= 0 || endPos <= 0
                    if (!needsToHoistStart) {
                        const diff = (startTRight - endTLeft) / 2 + overlapOffset
                        startPos = startPos - diff
                        endPos = endPos - diff
                    } else {
                        if (startPos <= 0) {
                            endPos -= ceil(overlapOffset * (1 - (totalWidth - (endPos + endTWidth)) / (endTWidth + overlapOffset * 2)))
                        }
                        if (endPos <= 0) {
                            startPos -= ceil(overlapOffset * (1 - (totalWidth - (startPos + startTWidth)) / (startTWidth + overlapOffset * 2)))
                        }
                    }

                    startPos = max([0, startPos])
                    endPos = max([0, endPos])
                }

                if (needsToHoistStart) {
                    startT.style.height = (startTOriginalHeight * 2) + 'px'
                } else {
                    startT.style.height = startTOriginalHeight + 'px'
                }

                // startT.style.left = this.pixel2Percent(startPos || 0)// startPos || 0) + 'px'
                // endT.style.right = this.pixel2Percent(endPos || 0) //(endPos || 0) + 'px'
                startT.style.left = (startPos || 0) + 'px'
                endT.style.right = (endPos || 0) + 'px'
            })
        },

        updateTimeLine(time) {
            const elm = this.els.seek
            if (this.player?.isPlaying) {
                const {start, end} = this.innerValue
                const selected = this.els.selected
                const totalDuration = end - start
                const currentDuration = time - start
                const maxPixels = selected.clientWidth
                const scaleFactor = maxPixels / totalDuration

                const pos = max([0, min([maxPixels, floor(currentDuration * scaleFactor)])])
                elm.style.left = pos + 'px'
                elm.style.opacity = 1
            } else {
                elm.style.opacity = 0
            }
        },
    }
}
